// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vnsc-pane-label,
.rsc-pane-label {
	position: absolute;
	left: 0;
	width: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
	writing-mode: vertical-rl;
	transform: rotate(180deg);
	font-size: 9px;
	font-weight: 600;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	color: var(--vnsc-text-micro, #7c8798);
	pointer-events: none;
	user-select: none;
	z-index: 10;
}

.vnsc-pane-header,
.rsc-pane-header {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 16px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 4px;
	padding: 0;
	background: transparent;
	border-bottom: none;
	opacity: 0;
	pointer-events: none;
	transition: opacity 150ms ease;
	z-index: 50;
	min-width: 0;
}

.vnsc-pane-wrap:hover .vnsc-pane-header,
.vnsc-pane-wrap:focus-within .vnsc-pane-header,
.vnsc-pane-wrap--active .vnsc-pane-header,
.rsc-pane-wrap:hover .rsc-pane-header,
.rsc-pane-wrap:focus-within .rsc-pane-header,
.rsc-pane-wrap--active .rsc-pane-header {
	opacity: 1;
	pointer-events: auto;
}

.vnsc-pane-header__label,
.rsc-pane-header__label {
	display: inline-flex;
	align-items: center;
	min-height: 16px;
	padding: 0 6px;
	border-radius: 3px;
	background: color-mix(in srgb, var(--vnsc-surface, var(--vnsc-bg, #131722)) 90%, transparent);
	border: 1px solid color-mix(in srgb, var(--vnsc-border, rgba(148, 163, 184, 0.24)) 100%, transparent);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
	font-size: 10px;
	font-weight: 500;
	letter-spacing: 0.02em;
	color: var(--vnsc-text-secondary, #787b86);
	flex-shrink: 0;
}

.vnsc-pane-header__content,
.rsc-pane-header__content {
	display: flex;
	align-items: center;
	min-width: 0;
	flex: 1 1 auto;
	overflow: hidden;
}

.vnsc-pane-header__actions,
.rsc-pane-header__actions {
	display: inline-flex;
	align-items: center;
	gap: 2px;
	min-height: 16px;
	padding: 0 4px;
	border-radius: 4px;
	background: color-mix(in srgb, var(--vnsc-surface, var(--vnsc-bg, #131722)) 90%, transparent);
	border: 1px solid color-mix(in srgb, var(--vnsc-border, rgba(148, 163, 184, 0.24)) 100%, transparent);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
	margin-left: auto;
	margin-right: 0;
	flex-shrink: 0;
}

.vnsc-pane-btn,
.rsc-pane-btn {
	border: 1px solid transparent;
	background: transparent;
	color: var(--vnsc-text-secondary, #787b86);
	padding: 1px 4px;
	border-radius: 3px;
	cursor: pointer;
	font: inherit;
	line-height: 1;
	font-size: 12px;
	transition: color 0.15s ease, border-color 0.15s ease;
}

.vnsc-pane-btn:hover,
.rsc-pane-btn:hover {
	color: var(--vnsc-text-primary, #d1d4dc);
	border-color: rgba(255, 255, 255, 0.12);
}

.vnsc-pane-btn:disabled,
.rsc-pane-btn:disabled {
	opacity: 0.35;
	cursor: not-allowed;
	border-color: transparent;
}

.vnsc-pane-wrap,
.rsc-pane-wrap {
	overflow: visible;
}

.vnsc-series-picker,
.rsc-series-picker {
	position: absolute;
	min-width: 340px;
	max-width: min(480px, calc(100vw - 24px));
	box-sizing: border-box;
	padding: 6px;
	border-radius: 10px;
	background: var(--vnsc-surface, rgba(255, 255, 255, 0.98));
	border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.24));
	box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18);
	z-index: 70;
}

.vnsc-series-picker__search,
.rsc-series-picker__search {
	padding: 4px 6px 8px;
}

.vnsc-series-picker__search-input,
.rsc-series-picker__search-input {
	width: 100%;
	padding: 6px 10px;
	border-radius: var(--vnsc-radius-sm, 4px);
	border: 1px solid var(--vnsc-border-input, #2a2a2a);
	background: var(--vnsc-bg-input, #1a1f2e);
	color: var(--vnsc-text-primary, #e0e0e0);
	font-size: var(--vnsc-font-sm, 12px);
	outline: none;
	box-sizing: border-box;
}

.vnsc-series-picker__search-input:focus,
.rsc-series-picker__search-input:focus {
	border-color: var(--vnsc-accent, #2962ff);
}

.vnsc-series-picker__search-input::placeholder,
.rsc-series-picker__search-input::placeholder {
	color: var(--vnsc-text-muted, #64748b);
}

.vnsc-series-picker__list,
.rsc-series-picker__list {
	list-style: none;
	margin: 0;
	padding: 0;
	max-height: 320px;
	overflow: auto;
}

.vnsc-series-picker__item,
.rsc-series-picker__item {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 6px 10px;
	border: 0;
	border-radius: 6px;
	background: transparent;
	color: var(--vnsc-text, #1e2a3b);
	text-align: left;
	cursor: pointer;
	font-size: 13px;
	font-family: inherit;
	line-height: 1.4;
}

.vnsc-series-picker__item:hover,
.rsc-series-picker__item:hover {
	background: rgba(45, 156, 219, 0.12);
}

.vnsc-series-picker__item--active,
.rsc-series-picker__item--active {
	background: rgba(45, 156, 219, 0.16);
}

.vnsc-series-picker__label,
.rsc-series-picker__label {
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.vnsc-series-picker__check,
.rsc-series-picker__check {
	font-size: 12px;
	color: #2d9cdb;
	flex-shrink: 0;
}

.vnsc-series-picker__empty,
.rsc-series-picker__empty {
	padding: 16px 10px;
	text-align: center;
	color: var(--vnsc-text-muted, #64748b);
	font-size: 13px;
}

.vnsc-series-picker__footer,
.rsc-series-picker__footer {
	margin-top: 6px;
	padding-top: 6px;
	border-top: 1px solid rgba(148, 163, 184, 0.18);
	font-size: 11px;
	color: var(--vnsc-text-muted, #64748b);
}

/* ─── Indicator Legend Chips ─────────────────────────────────────────────── */

.vnsc-indicator-legend,
.rsc-indicator-legend {
  position: absolute;
	top: 24px;          /* flush below the compact pane-header hover zone */
	left: 80px;         /* align with chart left margin (default 80px) */
	right: 8px;        /* avoid right y-axis area */
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px 0;
  /* Hidden by default — revealed on pane hover */
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms ease;
  z-index: 15;        /* above chart canvas (z=0), below pane-header (z=20) */
}

.vnsc-pane-header__legend,
.rsc-pane-header__legend {
	display: flex;
	position: static;
	top: auto;
	left: auto;
	right: auto;
	flex: 1 1 auto;
	min-width: 0;
	max-height: 16px;
	align-items: center;
	flex-wrap: nowrap;
	overflow-x: auto;
	overflow-y: hidden;
	gap: 3px;
	padding: 0;
	opacity: 1;
	pointer-events: auto;
	transition: none;
	z-index: auto;
	scrollbar-width: none;
}

.vnsc-pane-header__legend::-webkit-scrollbar,
.rsc-pane-header__legend::-webkit-scrollbar {
	display: none;
}

/* Reveal on hover (same trigger as .vnsc-pane-header) */
.vnsc-pane-wrap:hover .vnsc-indicator-legend,
.vnsc-pane-wrap:focus-within .vnsc-indicator-legend,
.vnsc-pane-wrap--active .vnsc-indicator-legend,
.rsc-pane-wrap:hover .rsc-indicator-legend,
.rsc-pane-wrap:focus-within .rsc-indicator-legend,
.rsc-pane-wrap--active .rsc-indicator-legend {
  opacity: 1;
  pointer-events: auto;
}

.vnsc-indicator-chip,
.rsc-indicator-chip {
  display: inline-flex;
  align-items: center;
	gap: 2px;
	padding: 0 5px;
	height: 16px;
	line-height: 1;
	box-sizing: border-box;
  border-radius: 4px;
  background: var(--vnsc-surface, rgba(255, 255, 255, 0.92));
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.24));
	font-size: 9px;
  font-weight: 500;
  color: var(--vnsc-text, #1e2a3b);
  cursor: default;
  user-select: none;
  white-space: nowrap;
}

.vnsc-indicator-chip--hidden,
.rsc-indicator-chip--hidden {
  opacity: 0.45;
}

.vnsc-indicator-chip__dot,
.rsc-indicator-chip__dot {
	width: 6px;
	height: 6px;
  border-radius: 50%;
  background-color: var(--chip-color, #2962ff);
  flex-shrink: 0;
}

.vnsc-indicator-chip__name,
.rsc-indicator-chip__name {
  white-space: nowrap;
}

.vnsc-indicator-chip__suffix,
.rsc-indicator-chip__suffix {
  margin-left: 3px;
  font-size: 8px;
  font-weight: 600;
  color: var(--chip-color, #2962ff);
}

.vnsc-indicator-chip__btn,
.rsc-indicator-chip__btn {
  border: 0;
  background: transparent;
  color: inherit;
	padding: 0 1px;
  cursor: pointer;
	font-size: 10px;
  line-height: 1;
  border-radius: 2px;
  display: flex;
  align-items: center;
}

.vnsc-indicator-chip__btn:hover,
.rsc-indicator-chip__btn:hover {
  background: rgba(148, 163, 184, 0.18);
}

.vnsc-indicator-chip__btn--remove,
.rsc-indicator-chip__btn--remove {
  opacity: 0.5;
}

.vnsc-indicator-chip__btn--remove:hover,
.rsc-indicator-chip__btn--remove:hover {
  opacity: 1;
  color: #f23645;
  background: rgba(242, 54, 69, 0.08);
}

/* P3-a + UI-P1: hover-reveal chip actions on hover-capable pointers only.
   Touch + keyboard users keep buttons always visible (a11y).
   UI-P1 collapses idle buttons out of layout (width/max-width/margin) so no
   ghost gap remains after the series name; they slide open on chip hover. */
@media (hover: hover) {
  .vnsc-indicator-chip__btn,
  .rsc-indicator-chip__btn {
    width: 0;
    max-width: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
    opacity: 0;
    transform: scale(0.8);
    transition: width 140ms ease, max-width 140ms ease, margin 140ms ease,
      opacity 120ms ease, transform 140ms ease;
  }
  .vnsc-indicator-chip:hover .vnsc-indicator-chip__btn,
  .rsc-indicator-chip:hover .rsc-indicator-chip__btn,
  .vnsc-indicator-chip:focus-within .vnsc-indicator-chip__btn,
  .rsc-indicator-chip:focus-within .rsc-indicator-chip__btn,
  .vnsc-indicator-chip__btn:focus-visible,
  .rsc-indicator-chip__btn:focus-visible {
    width: 14px;
    max-width: 14px;
    margin-left: 2px;
    opacity: 0.7;
    transform: scale(1);
  }
  .vnsc-indicator-chip__btn:hover,
  .rsc-indicator-chip__btn:hover {
    opacity: 1;
  }
}

/* UI-P3: live series value next to the chip name; tabular figures don't jitter. */
.vnsc-indicator-chip__value,
.rsc-indicator-chip__value {
  margin-left: 4px;
  font-variant-numeric: tabular-nums;
  color: var(--chip-color, inherit);
}


`, "",{"version":3,"sources":["webpack://./src/widget/styles/pane-overlays.css"],"names":[],"mappings":"AAAA;;CAEC,kBAAkB;CAClB,OAAO;CACP,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,sCAAsC;CACtC,oBAAoB;CACpB,iBAAiB;CACjB,WAAW;AACZ;;AAEA;;CAEC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,QAAQ;CACR,UAAU;CACV,uBAAuB;CACvB,mBAAmB;CACnB,UAAU;CACV,oBAAoB;CACpB,8BAA8B;CAC9B,WAAW;CACX,YAAY;AACb;;AAEA;;;;;;CAMC,UAAU;CACV,oBAAoB;AACrB;;AAEA;;CAEC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,6FAA6F;CAC7F,qGAAqG;CACrG,0BAA0B;CAC1B,kCAAkC;CAClC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,0CAA0C;CAC1C,cAAc;AACf;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,cAAc;CACd,gBAAgB;AACjB;;AAEA;;CAEC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,6FAA6F;CAC7F,qGAAqG;CACrG,0BAA0B;CAC1B,kCAAkC;CAClC,iBAAiB;CACjB,eAAe;CACf,cAAc;AACf;;AAEA;;CAEC,6BAA6B;CAC7B,uBAAuB;CACvB,0CAA0C;CAC1C,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,aAAa;CACb,cAAc;CACd,eAAe;CACf,qDAAqD;AACtD;;AAEA;;CAEC,wCAAwC;CACxC,uCAAuC;AACxC;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;CAChB,yCAAyC;CACzC,sBAAsB;CACtB,YAAY;CACZ,mBAAmB;CACnB,0DAA0D;CAC1D,+DAA+D;CAC/D,8CAA8C;CAC9C,WAAW;AACZ;;AAEA;;CAEC,oBAAoB;AACrB;;AAEA;;CAEC,WAAW;CACX,iBAAiB;CACjB,yCAAyC;CACzC,mDAAmD;CACnD,yCAAyC;CACzC,wCAAwC;CACxC,oCAAoC;CACpC,aAAa;CACb,sBAAsB;AACvB;;AAEA;;CAEC,yCAAyC;AAC1C;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;;CAEC,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,iBAAiB;CACjB,cAAc;AACf;;AAEA;;CAEC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,QAAQ;CACR,iBAAiB;CACjB,SAAS;CACT,kBAAkB;CAClB,uBAAuB;CACvB,gCAAgC;CAChC,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,OAAO;CACP,YAAY;CACZ,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;;CAEC,eAAe;CACf,cAAc;CACd,cAAc;AACf;;AAEA;;CAEC,kBAAkB;CAClB,kBAAkB;CAClB,sCAAsC;CACtC,eAAe;AAChB;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB,+CAA+C;CAC/C,eAAe;CACf,sCAAsC;AACvC;;AAEA,+EAA+E;;AAE/E;;EAEE,kBAAkB;CACnB,SAAS,WAAW,mDAAmD;CACvE,UAAU,UAAU,gDAAgD;CACpE,UAAU,SAAS,4BAA4B;EAC9C,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+CAA+C;EAC/C,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW,SAAS,uDAAuD;AAC7E;;AAEA;;CAEC,aAAa;CACb,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,WAAW;CACX,cAAc;CACd,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,UAAU;CACV,oBAAoB;CACpB,gBAAgB;CAChB,aAAa;CACb,qBAAqB;AACtB;;AAEA;;CAEC,aAAa;AACd;;AAEA,wDAAwD;AACxD;;;;;;EAME,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;CACpB,QAAQ;CACR,cAAc;CACd,YAAY;CACZ,cAAc;CACd,sBAAsB;EACrB,kBAAkB;EAClB,0DAA0D;EAC1D,+DAA+D;CAChE,cAAc;EACb,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;CAEC,UAAU;CACV,WAAW;EACV,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,cAAc;CACf,cAAc;EACb,eAAe;CAChB,eAAe;EACd,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;4EAG4E;AAC5E;EACE;;IAEE,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB;8CAC0C;EAC5C;EACA;;;;;;IAME,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA,kFAAkF;AAClF;;EAEE,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC","sourcesContent":[".vnsc-pane-label,\r\n.rsc-pane-label {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\twidth: 18px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twriting-mode: vertical-rl;\r\n\ttransform: rotate(180deg);\r\n\tfont-size: 9px;\r\n\tfont-weight: 600;\r\n\tletter-spacing: 0.5px;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--vnsc-text-micro, #7c8798);\r\n\tpointer-events: none;\r\n\tuser-select: none;\r\n\tz-index: 10;\r\n}\r\n\r\n.vnsc-pane-header,\r\n.rsc-pane-header {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\theight: 16px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: flex-start;\r\n\tgap: 4px;\r\n\tpadding: 0;\r\n\tbackground: transparent;\r\n\tborder-bottom: none;\r\n\topacity: 0;\r\n\tpointer-events: none;\r\n\ttransition: opacity 150ms ease;\r\n\tz-index: 50;\r\n\tmin-width: 0;\r\n}\r\n\r\n.vnsc-pane-wrap:hover .vnsc-pane-header,\r\n.vnsc-pane-wrap:focus-within .vnsc-pane-header,\r\n.vnsc-pane-wrap--active .vnsc-pane-header,\r\n.rsc-pane-wrap:hover .rsc-pane-header,\r\n.rsc-pane-wrap:focus-within .rsc-pane-header,\r\n.rsc-pane-wrap--active .rsc-pane-header {\r\n\topacity: 1;\r\n\tpointer-events: auto;\r\n}\r\n\r\n.vnsc-pane-header__label,\r\n.rsc-pane-header__label {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tmin-height: 16px;\r\n\tpadding: 0 6px;\r\n\tborder-radius: 3px;\r\n\tbackground: color-mix(in srgb, var(--vnsc-surface, var(--vnsc-bg, #131722)) 90%, transparent);\r\n\tborder: 1px solid color-mix(in srgb, var(--vnsc-border, rgba(148, 163, 184, 0.24)) 100%, transparent);\r\n\tbackdrop-filter: blur(4px);\r\n\t-webkit-backdrop-filter: blur(4px);\r\n\tfont-size: 10px;\r\n\tfont-weight: 500;\r\n\tletter-spacing: 0.02em;\r\n\tcolor: var(--vnsc-text-secondary, #787b86);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-pane-header__content,\r\n.rsc-pane-header__content {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tmin-width: 0;\r\n\tflex: 1 1 auto;\r\n\toverflow: hidden;\r\n}\r\n\r\n.vnsc-pane-header__actions,\r\n.rsc-pane-header__actions {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 2px;\r\n\tmin-height: 16px;\r\n\tpadding: 0 4px;\r\n\tborder-radius: 4px;\r\n\tbackground: color-mix(in srgb, var(--vnsc-surface, var(--vnsc-bg, #131722)) 90%, transparent);\r\n\tborder: 1px solid color-mix(in srgb, var(--vnsc-border, rgba(148, 163, 184, 0.24)) 100%, transparent);\r\n\tbackdrop-filter: blur(4px);\r\n\t-webkit-backdrop-filter: blur(4px);\r\n\tmargin-left: auto;\r\n\tmargin-right: 0;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-pane-btn,\r\n.rsc-pane-btn {\r\n\tborder: 1px solid transparent;\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary, #787b86);\r\n\tpadding: 1px 4px;\r\n\tborder-radius: 3px;\r\n\tcursor: pointer;\r\n\tfont: inherit;\r\n\tline-height: 1;\r\n\tfont-size: 12px;\r\n\ttransition: color 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.vnsc-pane-btn:hover,\r\n.rsc-pane-btn:hover {\r\n\tcolor: var(--vnsc-text-primary, #d1d4dc);\r\n\tborder-color: rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.vnsc-pane-btn:disabled,\r\n.rsc-pane-btn:disabled {\r\n\topacity: 0.35;\r\n\tcursor: not-allowed;\r\n\tborder-color: transparent;\r\n}\r\n\r\n.vnsc-pane-wrap,\r\n.rsc-pane-wrap {\r\n\toverflow: visible;\r\n}\r\n\r\n.vnsc-series-picker,\r\n.rsc-series-picker {\r\n\tposition: absolute;\r\n\tmin-width: 340px;\r\n\tmax-width: min(480px, calc(100vw - 24px));\r\n\tbox-sizing: border-box;\r\n\tpadding: 6px;\r\n\tborder-radius: 10px;\r\n\tbackground: var(--vnsc-surface, rgba(255, 255, 255, 0.98));\r\n\tborder: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.24));\r\n\tbox-shadow: 0 18px 48px rgba(15, 23, 42, 0.18);\r\n\tz-index: 70;\r\n}\r\n\r\n.vnsc-series-picker__search,\r\n.rsc-series-picker__search {\r\n\tpadding: 4px 6px 8px;\r\n}\r\n\r\n.vnsc-series-picker__search-input,\r\n.rsc-series-picker__search-input {\r\n\twidth: 100%;\r\n\tpadding: 6px 10px;\r\n\tborder-radius: var(--vnsc-radius-sm, 4px);\r\n\tborder: 1px solid var(--vnsc-border-input, #2a2a2a);\r\n\tbackground: var(--vnsc-bg-input, #1a1f2e);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tfont-size: var(--vnsc-font-sm, 12px);\r\n\toutline: none;\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n.vnsc-series-picker__search-input:focus,\r\n.rsc-series-picker__search-input:focus {\r\n\tborder-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.vnsc-series-picker__search-input::placeholder,\r\n.rsc-series-picker__search-input::placeholder {\r\n\tcolor: var(--vnsc-text-muted, #64748b);\r\n}\r\n\r\n.vnsc-series-picker__list,\r\n.rsc-series-picker__list {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tmax-height: 320px;\r\n\toverflow: auto;\r\n}\r\n\r\n.vnsc-series-picker__item,\r\n.rsc-series-picker__item {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 8px;\r\n\tpadding: 6px 10px;\r\n\tborder: 0;\r\n\tborder-radius: 6px;\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text, #1e2a3b);\r\n\ttext-align: left;\r\n\tcursor: pointer;\r\n\tfont-size: 13px;\r\n\tfont-family: inherit;\r\n\tline-height: 1.4;\r\n}\r\n\r\n.vnsc-series-picker__item:hover,\r\n.rsc-series-picker__item:hover {\r\n\tbackground: rgba(45, 156, 219, 0.12);\r\n}\r\n\r\n.vnsc-series-picker__item--active,\r\n.rsc-series-picker__item--active {\r\n\tbackground: rgba(45, 156, 219, 0.16);\r\n}\r\n\r\n.vnsc-series-picker__label,\r\n.rsc-series-picker__label {\r\n\tflex: 1;\r\n\tmin-width: 0;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.vnsc-series-picker__check,\r\n.rsc-series-picker__check {\r\n\tfont-size: 12px;\r\n\tcolor: #2d9cdb;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-series-picker__empty,\r\n.rsc-series-picker__empty {\r\n\tpadding: 16px 10px;\r\n\ttext-align: center;\r\n\tcolor: var(--vnsc-text-muted, #64748b);\r\n\tfont-size: 13px;\r\n}\r\n\r\n.vnsc-series-picker__footer,\r\n.rsc-series-picker__footer {\r\n\tmargin-top: 6px;\r\n\tpadding-top: 6px;\r\n\tborder-top: 1px solid rgba(148, 163, 184, 0.18);\r\n\tfont-size: 11px;\r\n\tcolor: var(--vnsc-text-muted, #64748b);\r\n}\r\n\r\n/* ─── Indicator Legend Chips ─────────────────────────────────────────────── */\r\n\r\n.vnsc-indicator-legend,\r\n.rsc-indicator-legend {\r\n  position: absolute;\r\n\ttop: 24px;          /* flush below the compact pane-header hover zone */\r\n\tleft: 80px;         /* align with chart left margin (default 80px) */\r\n\tright: 8px;        /* avoid right y-axis area */\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  padding: 4px 0;\r\n  /* Hidden by default — revealed on pane hover */\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 150ms ease;\r\n  z-index: 15;        /* above chart canvas (z=0), below pane-header (z=20) */\r\n}\r\n\r\n.vnsc-pane-header__legend,\r\n.rsc-pane-header__legend {\r\n\tdisplay: flex;\r\n\tposition: static;\r\n\ttop: auto;\r\n\tleft: auto;\r\n\tright: auto;\r\n\tflex: 1 1 auto;\r\n\tmin-width: 0;\r\n\tmax-height: 16px;\r\n\talign-items: center;\r\n\tflex-wrap: nowrap;\r\n\toverflow-x: auto;\r\n\toverflow-y: hidden;\r\n\tgap: 3px;\r\n\tpadding: 0;\r\n\topacity: 1;\r\n\tpointer-events: auto;\r\n\ttransition: none;\r\n\tz-index: auto;\r\n\tscrollbar-width: none;\r\n}\r\n\r\n.vnsc-pane-header__legend::-webkit-scrollbar,\r\n.rsc-pane-header__legend::-webkit-scrollbar {\r\n\tdisplay: none;\r\n}\r\n\r\n/* Reveal on hover (same trigger as .vnsc-pane-header) */\r\n.vnsc-pane-wrap:hover .vnsc-indicator-legend,\r\n.vnsc-pane-wrap:focus-within .vnsc-indicator-legend,\r\n.vnsc-pane-wrap--active .vnsc-indicator-legend,\r\n.rsc-pane-wrap:hover .rsc-indicator-legend,\r\n.rsc-pane-wrap:focus-within .rsc-indicator-legend,\r\n.rsc-pane-wrap--active .rsc-indicator-legend {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n}\r\n\r\n.vnsc-indicator-chip,\r\n.rsc-indicator-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n\tgap: 2px;\r\n\tpadding: 0 5px;\r\n\theight: 16px;\r\n\tline-height: 1;\r\n\tbox-sizing: border-box;\r\n  border-radius: 4px;\r\n  background: var(--vnsc-surface, rgba(255, 255, 255, 0.92));\r\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.24));\r\n\tfont-size: 9px;\r\n  font-weight: 500;\r\n  color: var(--vnsc-text, #1e2a3b);\r\n  cursor: default;\r\n  user-select: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.vnsc-indicator-chip--hidden,\r\n.rsc-indicator-chip--hidden {\r\n  opacity: 0.45;\r\n}\r\n\r\n.vnsc-indicator-chip__dot,\r\n.rsc-indicator-chip__dot {\r\n\twidth: 6px;\r\n\theight: 6px;\r\n  border-radius: 50%;\r\n  background-color: var(--chip-color, #2962ff);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.vnsc-indicator-chip__name,\r\n.rsc-indicator-chip__name {\r\n  white-space: nowrap;\r\n}\r\n\r\n.vnsc-indicator-chip__suffix,\r\n.rsc-indicator-chip__suffix {\r\n  margin-left: 3px;\r\n  font-size: 8px;\r\n  font-weight: 600;\r\n  color: var(--chip-color, #2962ff);\r\n}\r\n\r\n.vnsc-indicator-chip__btn,\r\n.rsc-indicator-chip__btn {\r\n  border: 0;\r\n  background: transparent;\r\n  color: inherit;\r\n\tpadding: 0 1px;\r\n  cursor: pointer;\r\n\tfont-size: 10px;\r\n  line-height: 1;\r\n  border-radius: 2px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.vnsc-indicator-chip__btn:hover,\r\n.rsc-indicator-chip__btn:hover {\r\n  background: rgba(148, 163, 184, 0.18);\r\n}\r\n\r\n.vnsc-indicator-chip__btn--remove,\r\n.rsc-indicator-chip__btn--remove {\r\n  opacity: 0.5;\r\n}\r\n\r\n.vnsc-indicator-chip__btn--remove:hover,\r\n.rsc-indicator-chip__btn--remove:hover {\r\n  opacity: 1;\r\n  color: #f23645;\r\n  background: rgba(242, 54, 69, 0.08);\r\n}\r\n\r\n/* P3-a + UI-P1: hover-reveal chip actions on hover-capable pointers only.\r\n   Touch + keyboard users keep buttons always visible (a11y).\r\n   UI-P1 collapses idle buttons out of layout (width/max-width/margin) so no\r\n   ghost gap remains after the series name; they slide open on chip hover. */\r\n@media (hover: hover) {\r\n  .vnsc-indicator-chip__btn,\r\n  .rsc-indicator-chip__btn {\r\n    width: 0;\r\n    max-width: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n    transition: width 140ms ease, max-width 140ms ease, margin 140ms ease,\r\n      opacity 120ms ease, transform 140ms ease;\r\n  }\r\n  .vnsc-indicator-chip:hover .vnsc-indicator-chip__btn,\r\n  .rsc-indicator-chip:hover .rsc-indicator-chip__btn,\r\n  .vnsc-indicator-chip:focus-within .vnsc-indicator-chip__btn,\r\n  .rsc-indicator-chip:focus-within .rsc-indicator-chip__btn,\r\n  .vnsc-indicator-chip__btn:focus-visible,\r\n  .rsc-indicator-chip__btn:focus-visible {\r\n    width: 14px;\r\n    max-width: 14px;\r\n    margin-left: 2px;\r\n    opacity: 0.7;\r\n    transform: scale(1);\r\n  }\r\n  .vnsc-indicator-chip__btn:hover,\r\n  .rsc-indicator-chip__btn:hover {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* UI-P3: live series value next to the chip name; tabular figures don't jitter. */\r\n.vnsc-indicator-chip__value,\r\n.rsc-indicator-chip__value {\r\n  margin-left: 4px;\r\n  font-variant-numeric: tabular-nums;\r\n  color: var(--chip-color, inherit);\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
